import { CountryCallingCode } from 'gtx-react/utils/extractProfileData';
import { ApiResponse } from 'types/api-response';

export type RegisterFormValues = {
    tipoimpresa: '0' | '1';
    nome: string;
    cognome: string;
    nomesocieta: string;
    email: string;
    idComune: number | null;
    telefono: string;
    prefisso: CountryCallingCode | null;
    privacy: boolean;
    piva: string;
};

type PickKeyValue<T extends keyof RegisterFormValues> = keyof Pick<RegisterFormValues, T>;

export const REGISTER_FORM_KEYS: {
    TIPOIMPRESA: PickKeyValue<'tipoimpresa'>;
    NOME: PickKeyValue<'nome'>;
    COGNOME: PickKeyValue<'cognome'>;
    NOMESOCIETA: PickKeyValue<'nomesocieta'>;
    EMAIL: PickKeyValue<'email'>;
    ID_COMUNE: PickKeyValue<'idComune'>;
    TELEFONO: PickKeyValue<'telefono'>;
    PREFISSO: PickKeyValue<'prefisso'>;
    PRIVACY: PickKeyValue<'privacy'>;
    PIVA: PickKeyValue<'piva'>;
} = {
    TIPOIMPRESA: 'tipoimpresa',
    NOME: 'nome',
    COGNOME: 'cognome',
    NOMESOCIETA: 'nomesocieta',
    EMAIL: 'email',
    ID_COMUNE: 'idComune',
    TELEFONO: 'telefono',
    PREFISSO: 'prefisso',
    PRIVACY: 'privacy',
    PIVA: 'piva',
};

export type RegisterPayload = RegisterFormValues & {
    prefisso: string;
};

export type RegisterApiResponse = ApiResponse<RegisterPayload>;
